// ClassDetail.js
import React from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import VideoPlayer from './video-player';

const ClassDetail = ({ selectedClass }) => {

    if (!selectedClass) return <p>Please select a class to see the details</p>;

    return (
        <div className='w-full'>
            {selectedClass?.fields.videoLink ? (
                <div className="video-player">
                    <VideoPlayer videoLink={selectedClass?.fields.videoLink} />
                </div>
            ) : (
                <p>No video available for this class</p>
            )}

            <h1 className="text-2xl font-bold mb-4">{selectedClass.fields.title || 'Untitled Class'}</h1>

            {selectedClass.fields.content ? (
                <div className='richTextArea text-base table'>{documentToReactComponents(selectedClass.fields.content)}</div>
            ) : (
                <p>No content available</p>
            )}

            <div className="mt-4">
                {selectedClass.fields.classMaterials ? (
                    selectedClass.fields.classMaterials.map((material, index) => (
                        <a
                            key={index}
                            target='_blank'
                            rel="noreferrer"
                            href={material.fields.file.url}
                            className="btn btn-secondary mt-2"
                            download
                        >
                            Download {material.fields.title || 'Material'}
                        </a>
                    ))
                ) : null}
            </div>
        </div>
    );
};

export default ClassDetail;